import React from "react"
import { motion } from "framer-motion"
import Logo from "../assets/svg/logo.svg"
const Popup = ({ onClose }) => {
  return (
    <motion.div
      className="fixed top-0 left-0 w-screen h-screen  flex justify-center items-center overflow-auto "
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 100,
        backdropFilter: "blur(5px)",
      }}
      onClick={onClose}
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div
        className="relative bg-white w-11/12 max-w-6xl p-8 md:p-20 flex flex-col items-start shadow-lg"
        onClick={e => e.stopPropagation()}
      >
        <div className="mb-10 md:mb-24 w-32">
          <Logo />
        </div>
        <div
          className="mb-4 font-display font-bold text-gray-800 leading-none"
          style={{ fontSize: "min(15vw, 225px)" }}
        >
          Hi
        </div>
        <div className="mb-12 font-inter font-normal text-black text-sm md:text-2xl leading-relaxed max-w-4xl tracking-tight">
          Just a quick note to confess: we’ve been super-busy helping our
          clients, and our own website has been seriously neglected. Sorry about
          that. While the work on there is still relevant, there’s actually a
          lot more brilliant stuff we’ve done recently that we’re still
          compiling. The new site will be live soon, but in the meantime, feel
          free to look around the old one to get a taste of what we’ve been up
          to (about two years ago). Feel free to get in contact to chat, and
          we’ll show you some recent work. Cheers. <br />
          <br />
          Craig <br />
          Managing & Creative Director
        </div>

        <div
          className="w-64 h-12 border border-black rounded-full cursor-pointer flex justify-center items-center hover:bg-gray-100 transition duration-300"
          onClick={onClose}
        >
          <div className="font-inter font-bold text-xs uppercase text-black tracking-wider pointer-events-none">
            Check out our old site
          </div>
        </div>
      </div>
    </motion.div>
  )
}

export default Popup
